<template>
  <div class="modal-card pop_min" id="draggable" style="overflow-y:hidden">
    <header class="modal-card-head pop-header">
      <button class="icon is-right" @click="move" style="position:absolute;top:18px;right:70px;z-index:30;"><i class="fas fa-window-maximize" style="color:#fff;font-size:22px;padding-top:1px"></i></button>
      <p class="modal-card-title tit">
        {{ title }}
        <button class="btn-pop-close delete" aria-label="close" @click="$parent.close()"></button>
      </p>
    </header>
    <section class="modal-card-body pop-content">
      <div class="inner-box">
        <div class="table-b" style="margin-bottom: 10px">
          <div class="table-header">
            <div class="table-name">
              <h3 class="ico_table_name">비밀번호 변경
                <span v-if="form.adminFlag" style="font-size:13pt;margin-right:30px;color:red">[관리자모드]</span>
              </h3>
            </div>
            <div class="btn-wrap btn-type1 clearfix fl_right">
              <div class="dp-ib fl_left">

                <!--관리자용 버튼 -->
                <button v-if="isAdmin" class="btn-size btn-red" @click="toggleAdmin">
                  {{ form.adminFlag ? '관리자 취소' : '관리자' }}
                </button>

                <button class="btn-size btn-blue" @click="setChangePassword()">변경</button>
              </div>
            </div>
          </div>

          <div v-if="form.adminFlag">
            <div style="font-size:11pt;text-align:left;margin-bottom:10px;color:red;">
              <p>* 사용자의 비밀번호를 변경하실수 있습니다.</p>
              <p>* 사용자 사번을 정확히 입력 후 변경하시기 바랍니다.</p>
            </div>
          </div>
          <div v-else>
            <div style="font-size:11pt;text-align:left;margin-bottom:10px">
              <p>* 비밀번호는 <span style="color:red">8~20자의 영문, 숫자, 특수문자</span>를 조합해서 사용할 수 있습니다.</p>
              <p>* 특수문자 사용으로 안전도가 높아져 도용의 위험이 줄어듭니다.</p>
            </div>
          </div>

          <div class="grid-wrap">
            <table class="visit-info-table">
              <colgroup>
                <col width="35%">
                <col width="*">
              </colgroup>

              <tr v-if="!form.adminFlag">
                <td class="tit">User ID</td>
                <td>
                  <div class="write">
                    <p>{{ loginId }}</p>
                  </div>
                </td>
              </tr>
              <tr v-if="!form.adminFlag">
                <td class="tit">현재 비밀번호</td>
                <td>
                  <input class="input" type="password" style="width:100%;" ref="nowPassword" v-model="form.nowPassword">
                </td>
              </tr>

              <tr v-if="form.adminFlag">
                <td class="tit">사용자 사번</td>
                <td>
                  <input class="input" type="text" style="width:100%;" ref="userEmpNo" v-model="form.userEmpNo">
                </td>
              </tr>

              <tr>
                <td class="tit">변경 비밀번호</td>
                <td>
                  <input class="input" type="password" style="width:100%;" ref="chgPassword" v-model="form.chgPassword">
                </td>
              </tr>
              <tr>
                <td class="tit">비밀번호 확인</td>
                <td>
                  <input class="input" type="password" style="width:100%;" ref="passwordConfirm" v-model="form.passwordConfirm">
                </td>
              </tr>
            </table>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  props: {
    loginId: {
      type: String,
      required: false
    },
    loginNm: {
      type: String,
      required: false
    },
  },
  data() {
    return {
      title: '비밀번호 변경',
      isAdmin: this.$store.state.loginInfo.authorities[0].roleCd == 'ADMIN',
      form: {
        adminFlag:false,
        userEmpNo:'',
        nowPassword: '',
        chgPassword: '',
        passwordConfirm: '',
      },
      compLink:'',
      smsLength: '',
      loaded: false,
      isNew: false,
      isMxMn: true
    }
  },
  methods: {
    // 버튼을 클릭할 때 상태를 변경하는 함수
    toggleAdmin() {
      this.form.adminFlag = !this.form.adminFlag;
      this.form.userEmpNo = "";
      this.form.nowPassword = "";
      this.form.chgPassword = "";
      this.form.passwordConfirm = "";
    },

    move() {
      if(this.isMxMn) {
        $(".modal-card").removeClass('pop_min')
        $(".modal-card").addClass('pop_max');

        $(".animation-content").removeClass('pop_min')
        $(".animation-content").addClass('pop_max');
        this.isMxMn = false
      } else {
        $(".modal-card").removeClass('pop_max')
        $(".modal-card").addClass('pop_min');

        $(".animation-content").removeClass('pop_max')
        $(".animation-content").addClass('pop_min');
        this.isMxMn = true
      }
    },
    setChangePassword() {
      //관리자 모드일때 체크
      if(this.form.adminFlag == true) {
        //사용자 사번 필수 입력 체크
        if(this.form.userEmpNo === ""){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '사용자 사번 항목을 입력 바랍니다.'})
                ,10});
          this.$refs.userEmpNo.focus();
          return false;
        }

        //변경 비밀번호 필수 입력 체크
        if(this.form.chgPassword === ""){
          setTimeout(()=> {
            this.$swal({ type: 'warning', text: '변경 비밀번호 항목을 입력 바랍니다.' })
                ,10});
          this.$refs.chgPassword.focus();
          return false;
        }

        //비밀번호 확인 필수 입력 체크
        if(this.form.passwordConfirm === ""){
          setTimeout(()=> {
            this.$swal({ type: 'warning', text: '비밀번호 확인 항목을 입력 바랍니다.' })
                ,10});
          this.$refs.passwordConfirm.focus();
          return false;
        }
      } else {    //일반 비밀번호 변경일 때 체크
        //현재 비밀번호 필수 입력 체크
        if(this.form.nowPassword === ""){
          setTimeout(()=> {
            this.$swal({type: 'warning', text: '현재 비밀번호 항목을 입력 바랍니다.'})
                ,10});
          this.$refs.nowPassword.focus();
          return false;
        }

        //변경 비밀번호 필수 입력 체크
        if(this.form.chgPassword === ""){
          setTimeout(()=> {
            this.$swal({ type: 'warning', text: '변경 비밀번호 항목을 입력 바랍니다.' })
                ,10});
          this.$refs.chgPassword.focus();
          return false;
        }

        //비밀번호 확인 필수 입력 체크
        if(this.form.passwordConfirm === ""){
          setTimeout(()=> {
            this.$swal({ type: 'warning', text: '비밀번호 확인 항목을 입력 바랍니다.' })
                ,10});
          this.$refs.passwordConfirm.focus();
          return false;
        }

        //변경 비밀번호와 비밀번호 확인 일치여부 체크
        if( this.form.chgPassword != this.form.passwordConfirm){
          this.$swal({ type: 'warning', text: '변경 비밀번호와 비밀번호 확인이 일치 하지 않습니다.' })
          //alert("New Password and Verify Password not the same !!");
          return false;
        }

        //변경 비밀번호와 현재 비밀번호 확인 일치여부 체크
        if( this.form.nowPassword === this.form.chgPassword){
          this.$swal({ type: 'warning', text: '변경 비밀번호와 현재 비밀번호는 같을 수 없습니다.' })
          //alert("New Password cann't be same as Current Password !!");
          return false;
        }

        //8자리 이상 패스워드 확인 체크
        if( this.form.chgPassword.length < 8){
          this.$swal({ type: 'warning', text: '8자리 이상 패스워드 입력 바랍니다.' })
          return false;
        }

        //20자리 이하 패스워드 확인 체크
        if( this.form.chgPassword.length > 20){
          this.$swal({ type: 'warning', text: '20자리 이하 패스워드 입력 바랍니다.' })
          return false;
        }

        const numberCheck = this.form.chgPassword.search(/[0-9]/g)
        const upperCharCheck = this.form.chgPassword.search(/[A-Z]/ig)
        const lowerCharCheck = this.form.chgPassword.search(/[a-z]/ig)
        const spCharCheck = this.form.chgPassword.search(/[`~!@@#$%^&*|₩₩₩'₩";:₩/?]/gi)

        if(numberCheck < 0){
          this.$swal({ type: 'warning', text: '비밀번호에 숫자는 반드시 포함되어야 합니다.' })
          return false;
        }

        if(upperCharCheck < 0 && lowerCharCheck < 0){
          this.$swal({ type: 'warning', text: '비밀번호에 영문자는 반드시 포함되어야 합니다.' })
          return false;
        }

        if(spCharCheck < 0){
          this.$swal({ type: 'warning', text: '비밀번호에 특수문자는 반드시 포함되어야 합니다.' })
          return false;
        }
      }

      this.$swal({
        type: 'info',
        text: `비밀번호를 변경하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {
          this.$store.commit('loading')
          const param = JSON.parse(JSON.stringify(this.form))
          this.$http.post(`/api/v1/changePassword`, param
          ).then((response) => {

            if(this.form.adminFlag) {
              if( response.data == true ) {
                this.$parent.close()
                this.$swal({type: 'info', text: '완료되었습니다.'})
              } else {
                setTimeout(()=> {
                  this.$swal({ type: 'warning', text: '사용자를 찾을 수 없습니다.' })
                      ,10});
                this.$refs.nowPassword.focus();
                return false;
              }
            } else {
              if( response.data == true ) {
                this.$parent.close()
                this.$swal({type: 'info', text: '완료되었습니다.'})
              } else {
                setTimeout(()=> {
                  this.$swal({ type: 'warning', text: '현재 비밀번호가 일치 하지 않습니다.' })
                      ,10});
                this.$refs.nowPassword.focus();
                return false;
              }
            }

          }).catch((e) => {
            console.error(e);
          });

        }
      }).finally(()=>{
        this.$store.commit('finish')
      })
    },
  },
  watch: {
  },

  created() {
    if(this.$store.state.loginInfo.compCd === 'E0000001') {
      this.compLink = '/ijmt'
    } else if(this.$store.state.loginInfo.compCd === '222222') {
      this.compLink = '/ijbh'
    } else if(this.$store.state.loginInfo.compCd === '100010') {
      this.compLink = '/ijel'
    } else if(this.$store.state.loginInfo.compCd === '101600') {
      this.compLink = '/ijcs'
    } else if(this.$store.state.loginInfo.compCd === '101301') {
      this.compLink = '/ijdm'
    } else if(this.$store.state.loginInfo.compCd === '100015') {
      this.compLink = '/ijst'
    } else if(this.$store.state.loginInfo.compCd === '100002') {
      this.compLink = '/ijhd'
    } else if(this.$store.state.loginInfo.compCd === '222300') {
      this.compLink = '/ijap'
    }
  },
  mounted() {
    //pop slots modal move
    $(".animation-content").addClass('pop_min');
    $(".animation-content").draggable();
    //ModalSlot open z-index change
    $('.lnb').css('z-index', '4');
  },
  destroyed() {
    //ModalSlot open z-index change
    $('.lnb').css('z-index', '7');
  },
}
</script>

<style scoped>
.modal-card {
  width: auto;
}

.modal table {
  border-right: #adadad solid 0px;
}

.visit-info-table{
  border-top: 1px solid #aaaaaa;
  width: 100%;
}

.visit-info-table td {
  border-bottom: 1px solid #ddd;
  border-left:0px;
  color: #999;
  padding: 10px 0 10px 10px;
  font-size: 14px;
  vertical-align: middle;
}

.visit-info-table td input{
  width: 35%;
  height: 40px;
}

.visit-info-table td p input{
  width: 100%;
}

.visit-info-table td select{
  padding:10px 40px 10px 15px;
}

.visit-info-table td.tit{
  background: #f9f9f9;
  padding-left: 30px;
  color: #666;
  line-height: normal;
}

.visit-info-table td button{
  margin-left:10px;
}

.visit-info-list ul li .write {
  text-align: left;
  padding: 10px 0 10px 10px;
  vertical-align: middle;
}

.visit-info-list ul li .write {
  padding: 10px 0 10px 5px;
  width: 100%;
  text-align: center;
}

</style>
